import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const Sel = ({ value, onChange, options, placeholder = "Select", testid, className }) => (
  <Select value={value ?? ""} onValueChange={onChange}>
    <SelectTrigger className={className || "w-full"} data-testid={testid}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent className="bg-[#121212] border-border z-50">
      {options.map((o) => {
        const v = typeof o === "string" ? o : o.value;
        const l = typeof o === "string" ? o.replace(/_/g, " ") : o.label;
        return <SelectItem key={v} value={v} data-testid={`${testid}-opt-${v}`}>{l}</SelectItem>;
      })}
    </SelectContent>
  </Select>
);
